export default {
  title: 'Tableau de bord Tire Rack',
  info: 'Chaque colonne présente les réclamations Tire Rack créées ce mois-là, selon leur statut actuel ; les mois récents évoluent donc à mesure que les réclamations sont clôturées. Payées %, Refusées % et CWOP % sont des parts des réclamations traitées (clôturées, hors annulées). Les durées de cycle sont des jours entiers entre la création de la réclamation et le paiement ou le refus. Un tiret signifie qu\'il n\'y a pas de données ou rien à mesurer, pas zéro.',
  notAvailable: 'Le tableau de bord Tire Rack est réservé aux comptes Tire Rack.',
  loading: 'Chargement du tableau de bord Tire Rack…',
  noData: 'Aucune donnée n\'a été renvoyée pour cette période.',
  retry: 'Réessayer',
  error: {
    failed: 'Impossible de charger le tableau de bord Tire Rack. Veuillez réessayer.',
    forbidden: 'Vous n\'êtes pas autorisé à consulter ce rapport.',
  },
  range: {
    label: 'Période',
    last3Months: '3 derniers mois',
    last6Months: '6 derniers mois',
    last12Months: '12 derniers mois',
    yearToDate: 'Depuis le début de l\'année',
    custom: 'Personnalisée',
    startMonth: 'Mois de début',
    endMonth: 'Mois de fin',
    apply: 'Appliquer',
    invalid: 'Choisissez un mois de début antérieur ou égal au mois de fin, sur 120 mois au maximum.',
  },
  cwop: {
    title: 'Cause première CWOP',
    caption: 'Nombre (part du CWOP du mois). Une réclamation est clôturée sans paiement après 31 jours sans nouveau document ; le ou les deux derniers mois sont donc encore incomplets.',
    noInstallation: 'Documentation d\'installation non reçue',
    noPurchase: 'Documentation d\'achat du remplacement non reçue',
    noDocumentation: 'Documentation de remplacement et d\'installation non reçue',
    other: 'Autre / non déterminé',
  },
  metrics: {
    title: 'Indicateur',
    caption: 'Réclamations regroupées par mois de création (UTC), selon leur statut actuel.',
    created: 'Réclamations créées',
    paid: 'Réclamations payées',
    denied: 'Réclamations refusées',
    pending: 'Réclamations en attente',
    cwop: 'Réclamations CWOP',
    paidPercent: 'Payées %',
    deniedPercent: 'Refusées %',
    cwopPercent: 'CWOP %',
  },
  cycle: {
    title: 'Cycle moyen des réclamations',
    average: 'Durée moyenne du cycle de réclamation (jours moyens entre l\'ouverture et la clôture)',
    repair: 'Réparation',
    replace: 'Remplacement',
    within5Days: '% résolues en 5 jours',
  },
  dash: {
    unavailable: 'Non disponible',
    noProcessedClaims: 'Aucune réclamation traitée',
    noResolvedClaims: 'Aucune réclamation payée ou refusée',
    noQualifyingClaims: 'Aucune réclamation résolue concernée',
  },
};
